import { isNil } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import { DELIVERY_TYPES } from 'constants/sales'
import DeliveryTypeForm from 'forms/DeliveryTypeForm'

import { SmallDescr, NormalDescr } from './styles'

const DeliveryDropdown = ({
  dict,
  config,
  texts,
  isDisabled,
  deliveryType,
  deliveryAvailableTypes,
  changeDeliveryType,
}) => {
  const [defaultValues, setDefaultValues] = React.useState(null)
  const [options, setOptions] = React.useState(null)

  React.useEffect(
    function() {
      const nextOptions = deliveryAvailableTypes.map(({ code, value }) => ({
        value: value.toString(),
        label: texts.delivery_types[code],
      }))

      setOptions(nextOptions)
      setDefaultValues({
        delivery:
          nextOptions.length === 1
            ? nextOptions[0].value.toString()
            : config.default.toString(),
      })
    },
    [texts.delivery_types, config.default, deliveryAvailableTypes],
  )

  const description =
    deliveryType === DELIVERY_TYPES.courier ? (
      <SmallDescr
        as="p"
        dangerouslySetInnerHTML={{ __html: texts.delivery.courier }}
      />
    ) : (
      <NormalDescr dangerouslySetInnerHTML={{ __html: dict.info.address }} />
    )

  const handleChange = React.useCallback(
    value => !isNil(value) && changeDeliveryType(+value),
    [changeDeliveryType],
  )

  if (!options || !defaultValues) return null

  return (
    <>
      <DeliveryTypeForm
        defaultValues={defaultValues}
        options={options}
        isDisabled={isDisabled}
        onChange={handleChange}
      />
      <div className="mt-2">{description}</div>
    </>
  )
}

DeliveryDropdown.propTypes = {
  dict: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  texts: PropTypes.object.isRequired,
  changeDeliveryType: PropTypes.func.isRequired,
  deliveryType: PropTypes.number.isRequired,
  deliveryAvailableTypes: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default DeliveryDropdown
